import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, Heart } from 'lucide-react';
import { useCart } from '../../context/CartContext';


const ProductCard = ({ product, onAddToCart }) => {
  const [isWishlisted, setIsWishlisted] = React.useState(false);
  const [imageError, setImageError] = React.useState(false);

  const handleAddToCart = (e) => {
    e.preventDefault();
    onAddToCart(product);
  };

  const handleImageError = () => {
    console.warn(`Image failed to load for product ${product.id}:`, product.imageUrl);
    setImageError(true);
  };

  const placeholderImage = 'https://via.placeholder.com/300x300?text=Product+Image';

  console.log('joshua', JSON.stringify(product))
  // Pass category and type as query params so ProductView can fetch the product
  const productUrl = `/product/${product.id}?gender=${product.gender}&category=${product.category}&type=${product.type}`;

  return (
    <Link to={productUrl} className="group">
      <div className="bg-navy-light rounded-lg overflow-hidden shadow-sm hover:shadow-xl hover:shadow-primary/10 transition duration-300 border border-primary/10">
        {/* Product Image */}
        <div className="relative overflow-hidden bg-navy aspect-square">
          <img
            src={imageError ? placeholderImage : product.imageUrl}
            alt={product.name}
            className="w-full h-full object-cover group-hover:scale-110 transition duration-300"
            onError={handleImageError}
          />

          {/* Wishlist Button */}
          <button
            onClick={(e) => {
              e.preventDefault();
              setIsWishlisted(!isWishlisted);
            }}
            className="absolute top-3 right-3 bg-navy-light rounded-full p-2 shadow-md hover:shadow-lg transition opacity-0 group-hover:opacity-100"
          >
            <Heart
              size={18}
              className={isWishlisted ? 'fill-red-600 text-red-600' : 'text-gray-600'}
            />
          </button>

          {/* Sale Badge */}
          {product.discount && (
            <div className="absolute top-3 left-3 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded">
              -{product.discount}%
            </div>
          )}
        </div>

        {/* Product Info */}
        <div className="p-4">
          <p className="text-xs text-primary font-medium mb-1 capitalize">{product.category}</p>
          <h3 className="text-sm font-semibold text-gray-800 mb-2 line-clamp-2">
            {product.name}
          </h3>

          {/* Pricing */}
          {/* <div className="flex items-center gap-2 mb-3">
            <span className="text-lg font-bold text-primary">
              ${product.price?.toFixed(2)}
            </span>
            {product.originalPrice && (
              <span className="text-sm text-gray-500 line-through">
                ${product.originalPrice.toFixed(2)}
              </span>
            )}
          </div> */}

          {/* Rating */}
          {product.rating && (
            <div className="flex items-center gap-1 mb-3">
              <span className="text-xs font-medium text-primary">★</span>
              <span className="text-xs text-gray-500">
                {product.rating} ({product.reviews} reviews)
              </span>
            </div>
          )}

          {/* Add to Cart Button
          <button
            onClick={handleAddToCart}
            className="w-full bg-primary hover:bg-primary-dark text-white text-sm font-medium py-2 px-3 rounded-md transition flex items-center justify-center gap-2"
          >
            <ShoppingBag size={16} />
            Add to Cart
          </button> */}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;